import {Form, InputGroup} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import PropTypes from 'prop-types';
import {moveCursorToEnd, scrollToComponent} from "enqc-utilities/src/utils/Utilities";

export default class QRBarInput extends React.Component{

    pressTimer = null;

    constructor(props) {
        super(props);
        let {value} = this.props
        this.state = {
            hideKeyboard: true,
            wrapperId:Math.floor(performance.now() * 1e6)
        };
        this.inputRef = React.createRef();
    }

    callFocus(){
        let {value} = this.props
        let {hideKeyboard, wrapperId} = this.state
        const input = this.inputRef.current;
        if (input) {
            const prev = document.getElementById("focused-input");
            if (prev) {
                prev.removeAttribute("id");
                prev.readOnly = true
                // prev.blur()
                if(prev.classList.contains("bg-input-cust-warning")){
                    prev.classList.replace( "bg-input-cust-warning",'bg-light')
                }else{
                    prev.classList.add( 'bg-light')
                }
            }
            input.id = 'focused-input'
            input.readOnly = true ;
            if(input.classList.contains("bg-light")){
                input.classList.replace( "bg-light",'bg-input-cust-warning')
            }else{
                input.classList.add( 'bg-input-cust-warning')
            }
            const scannerWrapper = document.getElementById(wrapperId)
            const scannerInput = document.getElementById("scanner-input");
            if(scannerInput){
                setTimeout(()=>{
                    // alert(input.value)
                    scannerInput.innerHTML = input.value
                    if(scannerWrapper) {
                        scannerWrapper.appendChild(scannerInput)
                    }
                    if (scannerInput !== document.activeElement) {
                        scannerInput.focus({ preventScroll: true })
                    }
                    moveCursorToEnd(scannerInput)
                }, 100)
            }
            scrollToComponent(scannerWrapper, -350)
        }
    }

    enableKeyboard(e){
        const input = this.inputRef.current;
        if (input) {
            const scannerInput = document.getElementById("scanner-input");
            if (scannerInput) {
                scannerInput.readOnly = true ;
                scannerInput.blur();
            }

            const prev = document.getElementById("focused-input");
            if (prev) {
                prev.removeAttribute("id");
                if(prev.classList.contains("bg-input-cust-warning")){
                    prev.classList.replace( "bg-input-cust-warning",'bg-light')
                }else{
                    prev.classList.add( 'bg-light')
                }
                prev.blur()
            }

            let hideKeyboard = false
            input.id = 'focused-input'
            input.readOnly = hideKeyboard ;
            input.focus()
            if(input.classList.contains("bg-light")){
                input.classList.replace( "bg-light",'bg-input-cust-warning')
            }else{
                input.classList.add( 'bg-input-cust-warning')
            }
            this.setState({hideKeyboard})
        }
    }

    handleTouchStart = (e) => {
        this.pressTimer = setTimeout(() => this.enableKeyboard(e), 600);
    }

    handleTouchEnd = () => {
        clearTimeout(this.pressTimer);
    }

    internalOnClick = (e) => {
        let {onClick, hideKeyboard} = this.props
        if(e){
            e.preventDefault()
        }
        // this.callFocus()
        this.enableKeyboard(e)
        if(onClick){
            onClick(e)
        }
    }

    render() {
        let {hideKeyboard, focused, wrapperId} = this.state
        let {id, placeholder, label, value, centered, readOnly, icon, isError, errorMessage, size, capitalized, onFilled, style, clickable} = this.props
        id = id || "text"
        label = label || ""
        placeholder = placeholder || label

        onFilled = onFilled || ((value) => {})
        return (
            <React.Fragment>
                <Form.Group id={id} className={"mb-4 " + (this.props.clickable ? "clickable-input " : "") + (centered ? "text-center" : "")}>
                    <Form.Label className={centered ? "text-center" : ""}>{label}</Form.Label>
                    <InputGroup className={this.props.clickable ? "clickable-input" : ""} size={size}>
                        {icon && (
                            <InputGroup.Text style={{ borderColor: (isError ? '#FA5252' : '') }}>
                                <FontAwesomeIcon icon={icon} />
                            </InputGroup.Text>
                        )}
                        <Form.Control
                            ref={this.inputRef}
                            required={this.props.required}
                            type="text"
                            placeholder={readOnly ? "" : placeholder}
                            onChange={(e) => {
                                let val = e.target.value;
                                let enter = false ;
                                if(/[\r\n\t]/.test(val)){
                                    enter = true
                                    val = val.replace(/[\r\n\t]+/g, '');
                                }
                                if (capitalized && this.props.onChange) {
                                    val = val.replace(/\b\w/g, char => char.toUpperCase());
                                    this.props.onChange(val);
                                } else if (this.props.onChange) {
                                    this.props.onChange(val);
                                }
                                if(enter){
                                    const defaultScannerWrapper = document.getElementById("default-scanner-wrapper")
                                    const scannerInput = document.getElementById("scanner-input");
                                    scannerInput.innerHTML = ''
                                    defaultScannerWrapper.appendChild(scannerInput)
                                    onFilled(val)
                                    hideKeyboard = true ;
                                    e.target.readOnly = hideKeyboard
                                    this.setState({hideKeyboard})
                                }
                            }}
                            onKeyDown={(e)=>{
                                if((e.key === 'Enter') || (e.key === 'Tab')){
                                    const defaultScannerWrapper = document.getElementById("default-scanner-wrapper")
                                    const scannerInput = document.getElementById("scanner-input");
                                    scannerInput.innerHTML = ''
                                    defaultScannerWrapper.appendChild(scannerInput)
                                    onFilled(value)
                                    hideKeyboard = true ;
                                    e.target.readOnly = hideKeyboard
                                    this.setState({hideKeyboard})
                                }
                            }}
                            onTouchStart={this.handleTouchStart}
                            onTouchEnd={this.handleTouchEnd}
                            onClick={this.internalOnClick}
                            value={value || ''}
                            readOnly={hideKeyboard || readOnly}
                            inputMode={hideKeyboard?'none':'text'}
                            style={{paddingLeft:'6px', paddingRight:'6px', ...style}}
                            size={size}
                            className={"bg-light"}
                            // className={"autoCapitalize " + (clickable ? "clickable-input " : "") + (centered ? "text-center" : "")+ (focused?"bg-input-cust-warning":"bg-light")}
                        />
                    </InputGroup>
                    {isError && (
                        <Form.Control.Feedback type="invalid" style={{ display: 'unset', position: 'absolute' }}>
                            {errorMessage || placeholder}
                        </Form.Control.Feedback>
                    )}
                </Form.Group>
                <div id={wrapperId}></div>
                {/*<span>{wrapperId}</span>*/}
                {/*{*/}
                {/*    (this.inputRef &&(this.inputRef.current?.id === 'focused-input')) && (*/}
                {/*        // <div id="scanner-wrapper"></div>*/}
                {/*        <span>{wrapperId}</span>*/}
                {/*    )*/}
                {/*}*/}
            </React.Fragment>
        );
    }
}
QRBarInput.propTypes = {
    label:PropTypes.string.isRequired,
    value:PropTypes.string,
    placeholder:PropTypes.string,
    icon:PropTypes.any,
    required:PropTypes.bool,
    readOnly:PropTypes.bool,
    size:PropTypes.string,
    centered:PropTypes.bool,
    onChange:PropTypes.func,
    isError:PropTypes.bool,
    errorMessage:PropTypes.string,
    clickable:PropTypes.bool,
    capitalized:PropTypes.bool,
    onClick:PropTypes.func,
    onFilled:PropTypes.func,
}